export default [
  {
    path: "",
    redirect: "/onboard/connect/facebook",
  },
  {
    path: "connect",
    redirect: "/onboard/connect/facebook",
  },
  {
    path: "connect/facebook",
    name: "OnboardConnectFacebook",
    component: () => import("@/views/onboard/connect/FacebookAccount.vue"),
  },
  {
    path: "connect/business-manager",
    name: "OnboardConnectBusinessManager",
    component: () => import("@/views/onboard/connect/BusinessManager.vue"),
  },
  {
    path: "connect/ad-account",
    name: "OnboardConnectAdAccount",
    component: () => import("@/views/onboard/connect/AdAccount.vue"),
  },
  // {
  //   path: "connect/pixel",
  //   name: "OnboardConnectPixel",
  //   component: () => import("@/views/onboard/connect/Pixel.vue"),
  // },
  {
    path: "subscription",
    name: "OnboardSubscription",
    component: () => import("@/views/onboard/Subscription.vue"),
  },
  {
    path: "payment-info",
    component: () => import("@/views/onboard/PaymentInfo.vue"),
  },
  {
    path: "additional-info",
    component: () => import("@/views/onboard/AdditionalInfo.vue"),
  },
]
